module.exports = __webpack_public_path__ + "img/slot-machine.eaad21ef.png";